import { css } from 'linaria';

export const mainPriceReviewsClass = css`
  display: inline-block;
  font-weight: 700;
  font-size: var(--space-275);
  line-height: 29px;
  color: var(--text-primary);

  @media (--to-desktop) {
    font-size: 14px;
    line-height: var(--space-250);
  }
`;

export const primaryPriceFractCurrencyReviewsClass = css`
  display: inline-block;
  font-weight: 700;
  font-size: var(--space-150);
  line-height: var(--space-225);

  @media (--from-tablet) {
    font-size: var(--space-175);
    line-height: 23px;
  }
`;

export const mainPriceReviewsFormClass = css`
  font-weight: 700;
  font-size: var(--space-275);
  line-height: 29px;
  color: var(--text-primary);

  @media (--to-desktop) {
    font-size: var(--space-225);
    line-height: var(--space-275);
  }
`;

export const primaryPriceFractCurrencyReviewsFormClass = css`
  display: inline-block;
  font-weight: 700;
  font-size: var(--space-175);
  line-height: var(--space-250);

  @media (--to-desktop) {
    font-size: var(--space-150);
    line-height: var(--space-200);
  }
`;
